import { render } from "./FeaturesList.vue?vue&type=template&id=4b559bc9&scoped=true"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"

import "./FeaturesList.vue?vue&type=style&index=0&id=4b559bc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b559bc9"]])

export default __exports__